import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import IconDiamondGradient from '@/components/assets/icon_diamond_gradient.svg';
import { cn } from '@/lib/utils';
type PremiumBadgeProps = {
  className?: string;
  showLabel?: boolean;
};
export default function PremiumBadge(t0) {
  const $ = _c(14);
  const {
    className,
    showLabel: t1
  } = t0;
  const showLabel = t1 === undefined ? false : t1;
  const t = useTranslations("premium-badge");
  let t2;
  if ($[0] !== t) {
    t2 = t("label");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = showLabel && "gap-1 @min-[280px]:md:w-auto @min-[280px]:md:px-1.5";
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = cn("flex size-[34px] items-center justify-center rounded-full border-2 border-transparent", t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      background: "\n          linear-gradient(rgba(0, 179, 227, 0.5),rgba(201, 97, 217, 0.5)) padding-box,\n          linear-gradient(90deg, rgba(0, 179, 227, 0.5) 0%, rgba(201, 97, 217, 0.5) 100%) border-box\n        "
    };
    t6 = <IconDiamondGradient className="size-5" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== showLabel || $[8] !== t) {
    t7 = showLabel && <span className={cn("caption hidden font-bold text-white", "@min-[280px]:md:inline")}>{t("label")}</span>;
    $[7] = showLabel;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t7) {
    t8 = <div role="img" aria-label={t2} className={t4} style={t5}>{t6}{t7}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}